<template>
  <b-modal
    id="delete-question-element-modal"
    class="confirm-dialog"
    hide-header
    centered
    @shown="setQuestionElement"
  >
    <p class="modal-main-message">Are you sure you want delete the item?</p>
    <div slot="modal-footer">
      <b-btn
        @disabled="isLoading"
        variant="ghost"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'delete-question-element-modal')"
      >
        Cancel
      </b-btn>
      <b-btn
        v-bind:disabled="isLoading"
        variant="primary"
        class="ml-1"
        @click="onDelete"
      >
        <template v-if="isLoading"> Deleting... </template>
        <template v-else>Confirm</template>
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

function initDeleteElementObject() {
    return {
        pageIndex: null,
        questionIndex: null,
        elementIndex: null
    };
}

export default {
    name: "DeleteQuestionElementModal",
    props: ["pageId", "questionId", "elementId"],
    data() {
        return {
            deleteElementObject: initDeleteElementObject()
        };
    },
    methods: {
        ...mapActions("surveys", ["deleteQuestionElement"]),
        ...mapMutations("surveys", ["setStringifyContent", "setErrors"]),
        setQuestionElement() {
            Object.keys(this.questionProperties).forEach(key => {
                this.deleteElementObject[key] = this.questionProperties[key];
            });
        },
        onDelete() {

            // console.log(this.$parent.survey.pages
            //     .find(page => page.uuid === this.questionProperties.page_uuid)
            //     .questions[
            //         this.deleteElementObject.questionIndex
            //     ].contents.gigya_answer_ids);

            this.$parent.survey.pages
                .find(page => page.uuid === this.questionProperties.page_uuid)
                .questions[
                    this.deleteElementObject.questionIndex
                ].contents.elements.splice(
                    this.deleteElementObject.elementIndex,
                    1
                );

            if (this.$parent.survey.pages
                .find(page => page.uuid === this.questionProperties.page_uuid)
                .questions[
                    this.deleteElementObject.questionIndex
                ].contents.gigya_answer_ids !== undefined) {
                this.$parent.survey.pages
                .find(page => page.uuid === this.questionProperties.page_uuid)
                .questions[
                    this.deleteElementObject.questionIndex
                ].contents.gigya_answer_ids.splice(
                    this.deleteElementObject.elementIndex,
                    1
                );
                
                this.$parent.survey.pages
                .find(page => page.uuid === this.questionProperties.page_uuid)
                .questions[
                    this.deleteElementObject.questionIndex
                ].contents.images.splice(
                    this.deleteElementObject.elementIndex,
                    1
                );

                this.$parent.survey.pages
                .find(page => page.uuid === this.questionProperties.page_uuid)
                .questions[
                    this.deleteElementObject.questionIndex
                ].contents.images.forEach((item, index) => {
                    item.key = index;
                });

                this.$emit('reload');
            }

            if (this.questionProperties.question_uuid)
                this.setStringifyContent({
                    page_index: this.questionProperties.pageIndex,
                    question_uuid: this.questionProperties.question_uuid,
                    question_type: this.questionProperties.question_type
                });

            const errors = this.errors;
            if (this.questionProperties.question_type === "rating") {
                if (errors && Object.keys(errors).length > 0) {
                    Object.keys(errors).forEach(key => {
                        if (key.includes("label")) {
                            delete errors[key];
                        }
                    });
                }

                this.$parent.survey.pages
                    .find(
                        page => page.uuid === this.questionProperties.page_uuid
                    )
                    .questions[
                        this.deleteElementObject.questionIndex
                    ].contents.elements.map((rating, index) => {
                        if (!rating.label)
                            errors[`label_${index}`] =
                                "Rating label is required";
                    });

                this.setErrors(errors);
                }
            // this.$root.$emit('reload')
               
            this.$root.$emit(
                "bv::hide::modal",
                "delete-question-element-modal"
            );
        }
    },
    computed: {
        ...mapState("surveys", ["isLoading", "errors"]),
        ...mapGetters("surveys", ["questionProperties"])
    }
};
</script>

<style>
</style>
